module.exports = __webpack_public_path__ + "static/media/Preferred_driver.10a89fc5.png";